export default __webpack_public_path__ + "images/28fb1d1d78aae7c541370cfb9edc6ce5-getdata.svg";